import { useEffect, useState } from "react";

export type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

const MIN_WIDTH: Record<Exclude<Breakpoint, "xs">, number> = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

const ORDER: Breakpoint[] = ["xs", "sm", "md", "lg", "xl", "2xl"];

function resolve(width: number): Breakpoint {
  if (width >= MIN_WIDTH["2xl"]) return "2xl";
  if (width >= MIN_WIDTH.xl) return "xl";
  if (width >= MIN_WIDTH.lg) return "lg";
  if (width >= MIN_WIDTH.md) return "md";
  if (width >= MIN_WIDTH.sm) return "sm";
  return "xs";
}

export function useBreakpoint() {
  const [current, setCurrent] = useState<Breakpoint>(() =>
    typeof window === "undefined" ? "xl" : resolve(window.innerWidth)
  );

  useEffect(() => {
    const onResize = () => setCurrent(resolve(window.innerWidth));
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isAtLeast = (bp: Breakpoint) =>
    ORDER.indexOf(current) >= ORDER.indexOf(bp);
  const isBelow = (bp: Breakpoint) =>
    ORDER.indexOf(current) < ORDER.indexOf(bp);

  return { current, isAtLeast, isBelow };
}
